<h1 [ngClass]="classes">
  <ng-content></ng-content>
</h1>
